import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

interface Props {
  small?: boolean;
}

export const LoadingOverlay = ({ small }: Props) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%"
      top={0}
      left={0}
      position="absolute"
      data-testid="loading-overlay"
      zIndex={100}
      sx={{
        backgroundColor: "rgba(255,255,255, 0.6)",
      }}>
      <CircularProgress color="secondary" size={small ? 32 : 64} />
    </Box>
  );
};

export default LoadingOverlay;
